module.exports = __webpack_public_path__ + "static/img/pictureE.28281d80.png";